import * as React from "react";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { SizedTextDataInput } from "../../../../repertoire/components/textDataInput/TextDataInput";
import { CUE_SHEETS_WORK_SEARCHVIEW_STATE_KEY, CUE_SHEETS_LISTS_DATE_CREATED, CUE_SHEETS_LISTS_ID, CUE_SHEETS_LISTS_ORIGINAL_TITLE_STATE_KEY, CUE_SHEETS_LISTS_STATUS, CUE_SHEETS_LISTS_WORK_STATE_KEY } from "../../../Consts";
import { hideModal, showModal } from "../../../../redux/reducers/ModalReducer";
import { IMembersPortalField } from "../../../types/IMembersPortalField";
import DataGridTable from "../../../../repertoire/components/dataGridTable/DataGridTable";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IProductState } from "../../../../redux/types/IProductState";
import { MEMBERS_PORTAL } from "../../../../accounts/Consts";
import { DataSource } from "../../../../repertoire/types/DataSource";
import HeaderOneText from "../../../sharedComponents/text/HeaderOneText";
import { TERRITORY_LOOKUP, CUE_TYPE_LOOKUP, AV_VERSION_CATEGORY_LOOKUP, AV_CATEGORY_LOOKUP, CUE_SHEET_TYPE_LOOKUP, AV_WORK_DESTINATION_LOOKUP, AD_TYPE_LOOKUP, PRODUCTION_TYPE_LOOKUP, AGENCY_LOOKUP, AVI_SUBMISSION_EXCEPTION_LOOKUP, CODE_OF_REVISION_LOOKUP } from "../../../../lookup/Consts";
import { getLookupValues } from "../../../../lookup/services/LookupHelpers";
import { SizedDropdownDataInput } from "../../../../repertoire/components/dropdownDataInput/DropdownDataInput";
import FormattedTimeDataInput from "../../../../repertoire/components/timeFieldDataInput/FormattedTimeDataInput";
import { AVDETAILS_COUNTRY_OF_ORIGIN_STATE_KEY, AVDETAILS_VERSION_TERRITORY_STATE_KEY, AVDETAILS_TYPE_STATE_KEY, AVDETAILS_VERSION_CATEGORY_STATE_KEY, AVDETAILS_SUBMITTER_PERCENT_STATE_KEY, AVDETAILS_SERIES_IDENTIFIER_STATE_KEY, AVDETAILS_PRODUCTION_NUMBER_STATE_KEY, AVDETAILS_SOCIETY_SERIES_NUMBER_KEY, AVDETAILS_EPISODE_NUMER_STATE_KEY, AVDETAILS_YEAR_OF_PRODUCTION_STATE_KEY, AVDETAILS_TOTAL_DURATION_STATE_KEY, AVDETAILS_MUSIC_DURATION_STATE_KEY, AVDETAILS_AIRED_UNTIL_STATE_KEY, AVDETAILS_CATEGORY_STATE_KEY, AVDETAILS_CUE_SHEET_TYPE_STATE_KEY, AVDETAILS_DESTINATION_STATE_KEY, AVDETAILS_V_ISAN_STATE_KEY, AVDETAILS_COMMERICIAL_BRAND_STATE_KEY, AVDETAILS_COMMERCIAL_PRODUCT_STATE_KEY, AVDETAILS_COMMERCIAL_TYPE_STATE_KEY, AVDETAILS_COMMERCIAL_AGENCY_STATE_KEY, AVDETAILS_COMMERCIAL_FORM_STATE_KEY, AVDETAILS_PRODUCTION_STATE_KEY, AVDETAILS_SOCIETY_OF_ORIGINAL_MUSIC_STATE_KEY, AVDETAILS_AIR_DATE_STATE_KEY, AVDETAILS_DATE_OF_REVISION_STATE_KEY, AVDETAILS_DATE_OF_SUBMISSION_STATE_KEY, AVDETAILS_AVI_SUBMISSION_EXCEPTION_KEY, AVDETAILS_CODE_OF_REVISION_STATE_KEY } from "../../../../repertoire/Consts";
import { IProductAVWork } from "../../../../repertoire/types/IProductAVWork";
import SizedDateDataInput from "../../../../repertoire/components/dateDataInput/DateDataInput";
import { ProductDetailsMapper } from "../../../../repertoire/services/ProductDetailsMapper";
import { IProductName } from "../../../../repertoire/types/IProductName";
import { IProductNameDataItems } from "../../../../repertoire/types/IProductNameDataItems";
import { FormatFields } from "../../../../redux/types/FormatFields";

export interface ICueSheetsMaintenanceGeneralDataViewProps {
    dataGridTableData?: IRepertoireComponentDataItem;
    cueSheetsMaintenanceGeneralDataView: IMembersPortalComponentDataItem;
    cueSheetsMaintenanceGridsViewData?: IMembersPortalComponentDataItem;
    cueSheet: IProductState;
    isReadonly: boolean;
    lookupValues: ILookupDictionary;
    changesMade: boolean;    
    dataGridTableEditableFieldsData?: IMembersPortalComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal?: typeof showModal;
    hideModal?: typeof hideModal;
    incrementTempID?: () => void;
    activeHeaderSection?: string;
    isMandatory?: boolean;
    clearModalSearchResults?: () => void;
    getRegisteredWorkDetails?: (dataSource: string, registeredWorksID: number, lookupValues: ILookupDictionary, registeredWorkMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    registeredWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
}

interface ICueSheetsMaintenanceGeneralDataViewState {
    loaded: boolean;
    activeHeaderSection?: string;
}

export default class CueSheetsMaintenanceGeneralDataView extends React.PureComponent<
    ICueSheetsMaintenanceGeneralDataViewProps,
    ICueSheetsMaintenanceGeneralDataViewState> {
    viewData;
    constructor(props: ICueSheetsMaintenanceGeneralDataViewProps) {
        super(props);

        this.state = {
            activeHeaderSection: props.activeHeaderSection ?? "draftWorkWorkProperties",
            loaded: true
        };

        this.viewData = {};

        const {
            cueSheetsMaintenanceGeneralDataView: { fields }
        } = this.props;
        
        if (!fields || fields.length === 0) {
            return;
        }

        const visibleFields = fields.filter(field => !field.hidden);

        this.viewData = visibleFields.reduce((acc, field) => {
            acc[field.name] = field.data;
            return acc;
        }, {});
    }

    onClickHeaderSection = (activeHeaderSection: string) => {
        this.setState({
            activeHeaderSection
        });
    };

    renderGridViewHeaderSections = (header: IMembersPortalField) => {
        return (
            <div
                className={["headerSection", "activeSection"].join(" ")}
                key={header.name}
                data-testid={header.name + "-section"}
            >
                {header.data}
            </div>
        );
    };

    getAVWorkDetails(): IProductAVWork {
        return this.props.cueSheet.productAVWork ?? {
            totalDuration: 0,
            musicDuration: 0
        } as IProductAVWork;
    }

    render() {
        const {
            isReadonly,
            lookupValues,
            incrementTempID,
            dataGridTableData,
            cueSheetsMaintenanceGridsViewData,
            tabs,
            activeTab,
            cueSheet,
            clearModalSearchResults,
            showModal,
            hideModal,
            getRegisteredWorkDetails,
            registeredWorksMaintenanceGeneralDataViewData
        } = this.props;

        const avWorkDetails = this.getAVWorkDetails();
        const {
            airDate,
            airedUntil,
            versionCategory,
            category,
            codeOfRevision,
            countryOfOrigin,
            versionTerritory,
            cueSheetType,
            dateOfRevision,
            dateOfSubmission,
            destination,
            episodeNumber,
            musicDuration,
            productionNumber,
            societySeriesNumber,
            seriesIdentifier,
            totalDuration,
            type,
            vIsan,
            yearOfProduction,
            commercialBrand,
            commercialProduct,
            commercialAgency,
            commercialType,
            commercialForm,
            aviSubmissionException,
            production,
            submitterInterestPercent,
            societyOfOriginalMusic
        } = avWorkDetails;
        
        const { loaded, activeHeaderSection } = this.state;

        const productNames: IProductName[] = (this.props.cueSheet.productName as IProductNameDataItems[]).map(item => ({
            productNameID: item.productNameID,
            productCoreID: item.productCoreID,
            productNameType: item.productNameType?.value ?? '',
            name: item.name?.value ?? '',
            language: item.language?.value ?? ''
        }));

        const title = ProductDetailsMapper.getOriginalTitleFromProductNames(productNames);

        const productionLookupValues = getLookupValues(PRODUCTION_TYPE_LOOKUP, lookupValues);
        const productProductionCode = productionLookupValues.find(lookup => lookup.typeID === cueSheet.production)?.code ?? '';

        const getCueSheetStatus = (dataSource: string) => {
            return (dataSource == DataSource.Intray) ? 'Draft' : 'Registered';
        }

        if (loaded) {
            const isNew: boolean = cueSheet.id1 === null || cueSheet.id1 === '0';
            return (
                <>
                    <div className="topMargin">
                        <div className="row">
                            <div className="headerContainer">
                                {this.renderGridViewHeaderSections(cueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'membersPortalGeneralTitle'))}
                            </div>
                            {<SizedTextDataInput
                                fieldType={"text"}
                                label={this.viewData[CUE_SHEETS_LISTS_ORIGINAL_TITLE_STATE_KEY]}
                                fieldName={CUE_SHEETS_LISTS_ORIGINAL_TITLE_STATE_KEY}
                                changeData={null}
                                readOnly={true}
                                isHidden={false}
                                value={title}
                                isMandatory={false}
                            />}
                            {<SizedTextDataInput
                                fieldType={"text"}
                                label={this.viewData[CUE_SHEETS_LISTS_ID]}
                                fieldName={CUE_SHEETS_LISTS_ID}
                                changeData={null}
                                readOnly={true}
                                isHidden={isNew}
                                value={cueSheet.id1}
                                isMandatory={false}
                            />}
                            {<SizedTextDataInput
                                fieldType={"text"}
                                label={this.viewData[CUE_SHEETS_LISTS_STATUS]}
                                fieldName={CUE_SHEETS_LISTS_STATUS}
                                changeData={null}
                                readOnly={true}
                                isHidden={isNew}
                                value={getCueSheetStatus(cueSheet.status)}
                                isMandatory={false}
                            />}
                        </div>
                        <div className="row">
                            {<SizedTextDataInput
                                fieldType={"text"}
                                label={this.viewData[CUE_SHEETS_LISTS_DATE_CREATED]}
                                fieldName={CUE_SHEETS_LISTS_DATE_CREATED}
                                changeData={null}
                                readOnly={true}
                                isHidden={isNew}
                                value={cueSheet.dateCreated}
                                isMandatory={false}
                            />}
                        </div>
                    </div>

                    <div className="row">
                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(cueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'membersPortalAvWorkTitle'))}
                        </div>
                        <div className="row">
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_COUNTRY_OF_ORIGIN_STATE_KEY]}
                                fieldName={AVDETAILS_COUNTRY_OF_ORIGIN_STATE_KEY}
                                value={countryOfOrigin}
                                changeData={null}
                                options={getLookupValues(TERRITORY_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={false}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_VERSION_TERRITORY_STATE_KEY]}
                                fieldName={AVDETAILS_VERSION_TERRITORY_STATE_KEY}
                                value={versionTerritory}
                                changeData={null}
                                options={getLookupValues(TERRITORY_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={false}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_TYPE_STATE_KEY]}
                                fieldName={AVDETAILS_TYPE_STATE_KEY}
                                value={type}
                                changeData={null}
                                options={getLookupValues(CUE_TYPE_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={false}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_VERSION_CATEGORY_STATE_KEY]}
                                fieldName={AVDETAILS_VERSION_CATEGORY_STATE_KEY}
                                value={versionCategory}
                                changeData={null}
                                options={getLookupValues(AV_VERSION_CATEGORY_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={false}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_SUBMITTER_PERCENT_STATE_KEY]}
                                fieldName={AVDETAILS_SUBMITTER_PERCENT_STATE_KEY}
                                value={submitterInterestPercent}
                                changeData={null}
                                readOnly={true}
                                isHidden={false}
                                fieldType='integer'
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_SERIES_IDENTIFIER_STATE_KEY]}
                                fieldName={AVDETAILS_SERIES_IDENTIFIER_STATE_KEY}
                                value={seriesIdentifier}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_SERIES_IDENTIFIER_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_PRODUCTION_NUMBER_STATE_KEY]}
                                fieldName={AVDETAILS_PRODUCTION_NUMBER_STATE_KEY}
                                value={productionNumber}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_PRODUCTION_NUMBER_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_SOCIETY_SERIES_NUMBER_KEY]}
                                fieldName={AVDETAILS_SOCIETY_SERIES_NUMBER_KEY}
                                value={societySeriesNumber}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_SOCIETY_SERIES_NUMBER_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_EPISODE_NUMER_STATE_KEY]}
                                fieldName={AVDETAILS_EPISODE_NUMER_STATE_KEY}
                                value={episodeNumber}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_EPISODE_NUMER_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_YEAR_OF_PRODUCTION_STATE_KEY]}
                                fieldName={AVDETAILS_YEAR_OF_PRODUCTION_STATE_KEY}
                                value={yearOfProduction}
                                changeData={null}
                                readOnly={isReadonly}
                                fieldType='integer'
                                isHidden={!this.viewData[AVDETAILS_YEAR_OF_PRODUCTION_STATE_KEY]}
                            />
                            <FormattedTimeDataInput
                                fieldName={AVDETAILS_TOTAL_DURATION_STATE_KEY}
                                label={this.viewData[AVDETAILS_TOTAL_DURATION_STATE_KEY]}
                                isHidden={!this.viewData[AVDETAILS_TOTAL_DURATION_STATE_KEY]}
                                value={totalDuration}
                                changeData={null}
                                readOnly={isReadonly}
                                tabs={tabs}
                                activeTab={activeTab}
                            />
                            <FormattedTimeDataInput
                                fieldName={AVDETAILS_MUSIC_DURATION_STATE_KEY}
                                label={this.viewData[AVDETAILS_MUSIC_DURATION_STATE_KEY]}
                                isHidden={!this.viewData[AVDETAILS_MUSIC_DURATION_STATE_KEY]}
                                value={musicDuration ?? cueSheet.duration}
                                changeData={null}
                                readOnly={isReadonly}
                                tabs={tabs}
                                activeTab={activeTab}
                            />
                            <SizedDateDataInput
                                label={this.viewData[AVDETAILS_AIRED_UNTIL_STATE_KEY]}
                                fieldName={AVDETAILS_AIRED_UNTIL_STATE_KEY}
                                value={airedUntil ? airedUntil.toString() : null}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_AIRED_UNTIL_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_CATEGORY_STATE_KEY]}
                                fieldName={AVDETAILS_CATEGORY_STATE_KEY}
                                value={category}
                                changeData={null}
                                options={getLookupValues(AV_CATEGORY_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_CATEGORY_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_CUE_SHEET_TYPE_STATE_KEY]}
                                fieldName={AVDETAILS_CUE_SHEET_TYPE_STATE_KEY}
                                value={cueSheetType}
                                changeData={null}
                                options={getLookupValues(CUE_SHEET_TYPE_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_CUE_SHEET_TYPE_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_DESTINATION_STATE_KEY]}
                                fieldName={AVDETAILS_DESTINATION_STATE_KEY}
                                value={destination}
                                changeData={null}
                                options={getLookupValues(AV_WORK_DESTINATION_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_DESTINATION_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_V_ISAN_STATE_KEY]}
                                fieldName={AVDETAILS_V_ISAN_STATE_KEY}
                                value={vIsan}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_V_ISAN_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_COMMERICIAL_BRAND_STATE_KEY]}
                                fieldName={AVDETAILS_COMMERICIAL_BRAND_STATE_KEY}
                                value={commercialBrand}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_COMMERICIAL_BRAND_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_COMMERCIAL_PRODUCT_STATE_KEY]}
                                fieldName={AVDETAILS_COMMERCIAL_PRODUCT_STATE_KEY}
                                value={commercialProduct}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_COMMERCIAL_PRODUCT_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_COMMERCIAL_TYPE_STATE_KEY]}
                                fieldName={AVDETAILS_COMMERCIAL_TYPE_STATE_KEY}
                                value={commercialType}
                                changeData={null}
                                options={getLookupValues(AD_TYPE_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_COMMERCIAL_TYPE_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_COMMERCIAL_AGENCY_STATE_KEY]}
                                fieldName={AVDETAILS_COMMERCIAL_AGENCY_STATE_KEY}
                                value={commercialAgency}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_COMMERCIAL_AGENCY_STATE_KEY]}
                            />
                            <SizedTextDataInput
                                label={this.viewData[AVDETAILS_COMMERCIAL_FORM_STATE_KEY]}
                                fieldName={AVDETAILS_COMMERCIAL_FORM_STATE_KEY}
                                value={commercialForm}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_COMMERCIAL_FORM_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_PRODUCTION_STATE_KEY]}
                                fieldName={AVDETAILS_PRODUCTION_STATE_KEY}
                                value={production ?? productProductionCode}
                                changeData={null}
                                options={getLookupValues(PRODUCTION_TYPE_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_PRODUCTION_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_SOCIETY_OF_ORIGINAL_MUSIC_STATE_KEY]}
                                fieldName={AVDETAILS_SOCIETY_OF_ORIGINAL_MUSIC_STATE_KEY}
                                value={societyOfOriginalMusic}
                                changeData={null}
                                options={getLookupValues(AGENCY_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_SOCIETY_OF_ORIGINAL_MUSIC_STATE_KEY]}
                            />
                            <SizedDateDataInput
                                label={this.viewData[AVDETAILS_AIR_DATE_STATE_KEY]}
                                fieldName={AVDETAILS_AIR_DATE_STATE_KEY}
                                value={airDate ? airDate.toString() : null}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_AIR_DATE_STATE_KEY]}
                            />
                            <SizedDateDataInput
                                label={this.viewData[AVDETAILS_DATE_OF_REVISION_STATE_KEY]}
                                fieldName={AVDETAILS_DATE_OF_REVISION_STATE_KEY}
                                value={dateOfRevision ? dateOfRevision.toString() : null}
                                changeData={null}
                                readOnly={true}
                                isHidden={!this.viewData[AVDETAILS_DATE_OF_REVISION_STATE_KEY]}
                            />
                            <SizedDateDataInput
                                label={this.viewData[AVDETAILS_DATE_OF_SUBMISSION_STATE_KEY]}
                                fieldName={AVDETAILS_DATE_OF_SUBMISSION_STATE_KEY}
                                value={dateOfSubmission}
                                changeData={null}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_DATE_OF_SUBMISSION_STATE_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_AVI_SUBMISSION_EXCEPTION_KEY]}
                                fieldName={AVDETAILS_AVI_SUBMISSION_EXCEPTION_KEY}
                                value={aviSubmissionException}
                                changeData={null}
                                options={getLookupValues(AVI_SUBMISSION_EXCEPTION_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={isReadonly}
                                isHidden={!this.viewData[AVDETAILS_AVI_SUBMISSION_EXCEPTION_KEY]}
                            />
                            <SizedDropdownDataInput
                                label={this.viewData[AVDETAILS_CODE_OF_REVISION_STATE_KEY]}
                                fieldName={AVDETAILS_CODE_OF_REVISION_STATE_KEY}
                                value={codeOfRevision}
                                changeData={null}
                                options={getLookupValues(CODE_OF_REVISION_LOOKUP, lookupValues)}
                                allowNull={true}
                                readOnly={true}
                                isHidden={!this.viewData[AVDETAILS_CODE_OF_REVISION_STATE_KEY]}
                            />
                        </div>
                    </div>

                    {<div className="row">

                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections(cueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'membersPortalWorkTitle'))}
                        </div>

                        <DataGridTable
                            tableContents={cueSheet.productWork}
                            changeData={null}
                            dataGridTableData={dataGridTableData}
                            stateKey={CUE_SHEETS_LISTS_WORK_STATE_KEY}
                            componentInstance={CUE_SHEETS_WORK_SEARCHVIEW_STATE_KEY}
                            showRowNumber={false}
                            isReadOnly={true}
                            tableActions={null}
                            lookupValues={lookupValues}
                            incrementTempID={incrementTempID}
                            tabs={tabs}
                            activeTab={activeTab}
                            showDropdownsAsCodes={false}
                            clearModalSearchResults={clearModalSearchResults}
                            portalType={MEMBERS_PORTAL}
                            showModal={showModal}
                            hideModal={hideModal}
                            getRegisteredWorkDetails={getRegisteredWorkDetails}
                            registeredWorksMaintenanceGeneralDataViewData={registeredWorksMaintenanceGeneralDataViewData}
                        />

                    </div>}
                </>
            );
        }
        return <div />;
    }
}
